import { CONSORS_IDENTIFICATION_TYPES } from 'cpool-constants';
import { z } from 'zod';

export const schemaConsorsIdentificationType = z.nativeEnum(CONSORS_IDENTIFICATION_TYPES);
